"use client";

import React from "react";
var __jsx = React.createElement;
import { useRef } from "react";
import styles from "./audio-controller.module.css";
export function AudioController(_ref) {
  var src = _ref.src,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  var audioRef = useRef(null);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className)
  }, /*#__PURE__*/React.createElement("audio", {
    ref: audioRef,
    src: src,
    controls: true,
    preload: "metadata",
    className: "w-full h-12 rounded-lg ".concat(styles.audio),
    style: {
      borderRadius: "0.5rem",
      outline: "none"
    }
  }, "Your browser does not support the audio element."));
}